var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDireccionesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 7.5,
    fill: "#F0F1F3",
    stroke: "#666770"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 5.875C10.8945 5.875 8.375 8.27305 8.375 11.2266C8.375 14.625 12.125 20.0106 13.5019 21.8707C13.5591 21.9492 13.634 22.0131 13.7206 22.0572C13.8071 22.1012 13.9029 22.1242 14 22.1242C14.0971 22.1242 14.1929 22.1012 14.2794 22.0572C14.366 22.0131 14.4409 21.9492 14.4981 21.8707C15.875 20.0113 19.625 14.6277 19.625 11.2266C19.625 8.27305 17.1055 5.875 14 5.875Z",
    stroke: "#666770",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3125 11.3846C16.3125 12.6306 15.2845 13.6538 14 13.6538C12.7155 13.6538 11.6875 12.6306 11.6875 11.3846C11.6875 10.1386 12.7155 9.11536 14 9.11536C15.2845 9.11536 16.3125 10.1386 16.3125 11.3846Z",
    stroke: "#666770"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDireccionesIcon);
export default __webpack_public_path__ + "static/media/direccionesIcon.b423c747bce49473b4f4ed141c887277.svg";
export { ForwardRef as ReactComponent };